import { SansText } from '@velasca/ui/sans-text'
import { Container } from './SuccessMessage.styles'
import type { SuccessMessageProps } from './SuccessMessage.types'

export const SuccessMessage = ({
  message,
  buttonText,
  setStatus,
}: SuccessMessageProps): JSX.Element => {
  return (
    <Container>
      <SansText
        center
        color="dark"
        size="md"
        dangerouslySetInnerHTML={{ __html: message }}
      />

      <SansText
        center
        underline
        uppercase
        cursor="pointer"
        color="primary"
        onClick={() => {
          setStatus('idle')
        }}
      >
        {buttonText}
      </SansText>
    </Container>
  )
}
